import type { ExperimentTestName } from '@onramp/utils/experiments/experiments';
import fromPairs from 'lodash/fromPairs';

import { getCookie } from '../cookies/clientUtils';

import type { ExperimentGroupData } from './consts';
import { experimentCookieSchema } from './consts';
import { Experiments } from './experiments';

export function getOverriddenExperimentsFromCookie() {
  const parsedCookie = experimentCookieSchema.parse(
    getCookie({ cookieName: 'overridenExperiments' }),
  );

  return parsedCookie?.groups;
}

/**
 * Merges experiment arrays so that there are no duplicate tests in the returned value. The last element wins, so
 * `deduplicateExperimentArrays([{ test: 'some-test', group: 'control' }, { test: 'some-test', group: 'treatment' }])`
 * returns `[{ test: 'some-test', group: 'treatment' }]`
 */
export function deduplicateExperimentArrays(experimentData: ExperimentGroupData[]) {
  const experimentMap = fromPairs(
    experimentData.map((g) => [g.test, g] as [string, ExperimentGroupData]),
  );

  return Object.values(experimentMap);
}

export const isExperimentInTreatment = (
  groups: ExperimentGroupData[] | undefined,
  experimentName: ExperimentTestName,
) => {
  const name = Experiments[experimentName]?.name ?? '';
  return groups?.find((gr) => gr.test === name)?.group === 'treatment';
};
